import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink, from } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { setContext } from '@apollo/client/link/context'
import { ThrottledFetch } from '../utils/http/throttledFetch.util'

import { config } from '../config'
import { ACCESS_TOKEN, ACCESS_TOKEN_OAUTH } from '../services/legacyAuth.service'
import { oAuthHelper } from '../services/oAuth.service'

const cache = new InMemoryCache()

const defaultOptions = {
  watchQuery: {
    notifyOnNetworkStatusChange: true
  },
  query: {},
  mutate: {
    errorPolicy: 'all'
  }
}

const cleanTypename = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    const omitTypename = (key, value) => (key === '__typename' ? undefined : value)
    operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename)
  }
  return forward(operation)
})

const httpLink = createHttpLink({
  uri: config.graphqlUrl,
  credentials: 'include',
})

const withToken = setContext(async () => {
  const token = oAuthHelper.useOAuthSDK()
    ? localStorage.getItem(ACCESS_TOKEN_OAUTH)
    : localStorage.getItem(ACCESS_TOKEN)

  return {
    headers: {
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const resetToken = onError(({ networkError }) => {
  if (networkError && networkError.statusCode === 401) {
    // currently unused
  }
})

export const client = new ApolloClient({
  cache,
  link: from([
    cleanTypename,
    resetToken,
    withToken,
    httpLink
  ]),
  defaultOptions,
  queryDeduplication: false, // Disabled due to high frequent requests, such as query-on-filter-change forms
})

const throttledFetch = new ThrottledFetch()

const exportHttpLink = createHttpLink({
  uri: config.graphqlUrl,
  credentials: 'include',
  fetch: (input, init) => throttledFetch.fetch(input, init)
})

export const exportClient = new ApolloClient({
  cache,
  link: from([
    cleanTypename,
    resetToken,
    withToken,
    exportHttpLink
  ]),
  defaultOptions,
})

export default client